import React, { Component, Fragment } from 'react'
import ReactSwipe from 'react-swipe';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faChevronLeft,
  faChevronRight,
} from '@fortawesome/pro-solid-svg-icons';
export default class Gallery extends Component {
    constructor(props) {
		super(props);

		this.state = {
			error: null,
			gallery: null,
		};
	}

    getData(){
        setTimeout(() => {
          console.log('Our data is fetched');
          this.setState({
            gallery: this.props.gallery
          })
          console.log(this.state.gallery);
        }, 1000)
      }

      componentDidMount(){
        this.getData();
      }

      render() {
        const imageStyles = {
            width: "100%",
            height: "100%",
            objectFit: "contain",
            margin: "0 auto",
            // backgroundColor: "#000"
          };
        const imgContainerStyle = {
            width: "100vw",
            height: "400px",
            overflow: "hidden",
            textAlign: "center",
        }
        let reactSwipeEl;
        const startSlide = 0;
        const swipeOptions = {
        startSlide: startSlide,
        auto: 1000,
        speed: 1000,
        swiping: 0.2,
        disableScroll: true,
        continuous: true,
        callback() {
            console.log("slide changed");
        },
        transitionEnd() {
            console.log("ended transition");
        }
        };
		return (this.state.gallery) ? (
			<Fragment>
        <section className="gallery">
            <h2>Gallery</h2>
            <div className="gallery-swiper-wrapper">
              <ReactSwipe
                  className="carousel"
                  swipeOptions={{swipeOptions }}
                  ref={el => (reactSwipeEl = el)}
              >
                      {this.state.gallery.map((image, index) => (
                  <div key={index} style={imgContainerStyle} >
                      <img
                          alt={image.meta.title}
                          style={imageStyles}
                          src={process.env.REACT_APP_COCKPIT_URL + image.path} />
                  </div>
                      ))}
              </ReactSwipe>
              <div className="gallery-nav-wrapper">
                <div className="gallery-nav">
                  <button onClick={() => reactSwipeEl.prev()}>
                    <FontAwesomeIcon icon={faChevronLeft} size="2x" color="white" />
                  </button>
                  <button onClick={() => reactSwipeEl.next()}>
                    <FontAwesomeIcon icon={faChevronRight} size="2x" color="white" />
                  </button>
                </div>
              </div>
            </div>

        </section>
			</Fragment>
		) : (
			<Fragment />
		);
	}
}
